import React from "react";
import styled from "styled-components";

const ErrorContainer = styled.div`
  background-color: #fff5f5;
  border: 1px solid #ffa8a8;
  border-radius: 8px;
  padding: 20px;
  margin-top: 40px;
  box-shadow: 0 2px 4px rgba(255, 0, 0, 0.1);
  max-width: 95vw;
`;

const ErrorTitle = styled.h4`
  color: #e53e3e;
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
`;

const ErrorTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const ErrorTableHeader = styled.th`
  text-align: left;
  padding: 4px;
  border-bottom: 1px solid #ffa8a8;
  color: #e53e3e;
  font-size: 12px;
`;

const ErrorTableCell = styled.td`
  padding: 4px;
  border-bottom: 1px solid #ffa8a8;
  color: #c53030;
  font-size: 12px;
`;

const ErrorMessages = ({ errors }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <ErrorContainer>
      <ErrorTitle>Excel Upload Errors:</ErrorTitle>
      <ErrorTable>
        <thead>
          <tr>
            <ErrorTableHeader>Sheet</ErrorTableHeader>
            <ErrorTableHeader>In Row</ErrorTableHeader>
            <ErrorTableHeader>Product Name</ErrorTableHeader>
            <ErrorTableHeader>Column</ErrorTableHeader>
            <ErrorTableHeader>Error Message</ErrorTableHeader>
          </tr>
        </thead>
        <tbody>
          {errors.map((error, index) => (
            <tr key={index}>
              {error.sheet ? (
                <>
                  <ErrorTableCell>{error.sheet}</ErrorTableCell>
                  <ErrorTableCell>{error.row}</ErrorTableCell>
                  <ErrorTableCell>{error.product_name}</ErrorTableCell>
                  <ErrorTableCell>{error.column}</ErrorTableCell>
                  <ErrorTableCell>{error.message}</ErrorTableCell>
                </>
              ) : (
                <ErrorTableCell colSpan="5">
                  Unknown error. Please download the latest version of the template and try
                  again.
                </ErrorTableCell>
              )}
            </tr>
          ))}
        </tbody>
      </ErrorTable>
    </ErrorContainer>
  );
};

export default ErrorMessages;
